export {}
declare global {
    interface Sergiosgc { 
    }
    var sergiosgc: Sergiosgc;
}
if (!globalThis.sergiosgc) (globalThis.sergiosgc as any) = {}